import { push } from 'react-router-redux'
import { httpRequest } from 'http'

import { FEATURE_TYPES } from 'constants'
import { sendErrorNotification } from 'helpers/web_to_client'
import { serialize } from 'helpers'
import { isFeatureAvailable } from 'helpers/accounts'
import moment from 'moment'

import { LOG } from 'urls'

export const JOURNAL_REQUEST = 'journal/REQUEST'
export const JOURNAL_SUCCESS = 'journal/SUCCESS'
export const JOURNAL_MORE_SUCCESS = 'journal/MORE_SUCCESS'
export const JOURNAL_ERROR = 'journal/ERROR'
export const JOURNAL_SET_FILTER = 'journal/SET_FILTER'
export const JOURNAL_TAB_CHANGE = 'journal/TAB_CHANGE'
export const JOURNAL_RESET_STATE = 'journal/RESET_STATE'

export const JOURNAL_TABS_NAMES = [
    'battles',
    'resources',
    'reserves',
]
export const JOURNAL_TABS = {}
for (let tab_name of JOURNAL_TABS_NAMES) {
    JOURNAL_TABS[tab_name] = tab_name
}

export function openJournal(tab = null) {
    return (dispatch, getState) => {
        const isClanJournalAvailable = isFeatureAvailable(getState().account, FEATURE_TYPES.CLAN_JOURNAL)
        if (!isClanJournalAvailable) return

        if (JOURNAL_TABS_NAMES.includes(tab)) dispatch(setTab(tab))
        dispatch(push(LOG))
    }
}

export function filterResourcesByType(type, actions) {
    return (dispatch) => {
        dispatch(setFilter({
            resourceType: type,
            actions,
        }))
        dispatch(requestJournal())
    }
}

export function filterReservesByType(type, reserve_types) { // eslint-disable-line camelcase
    return (dispatch) => {
        dispatch(setFilter({
            reserveType: type,
            reserve_types,
        }))
        dispatch(requestJournal())
    }
}

export function filterBattlesByType(battle_type, max_vehicle_level) { // eslint-disable-line camelcase
    return (dispatch) => {
        dispatch(setFilter({
            battle_type,
            max_vehicle_level,
        }))
        dispatch(requestJournal())
    }
}

function setFilter(filter) {
    return {
        type: JOURNAL_SET_FILTER,
        payload: { filter },
    }
}

export function updateHistory() {
    return async (dispatch, getState) => {
        const state = getState().journal
        if (state.isLoading) return

        const eventDateKey = state.selectedTab === 'battles' ? 'finished_at' : 'created_at'
        const eventDates = state.records.data.map(record => record[eventDateKey])
        const minEventDate = Math.min.apply(null, eventDates)
        const minEventDayStart = Math.floor(moment(minEventDate * 1000).startOf('day').valueOf() / 1000)

        const url = getRequestUrl(minEventDayStart, state)

        httpRequest(url).then(
            records => dispatch(requestMoreSuccess(records)),
            errorData => dispatch(requestError(errorData)),
        )
    }
}

export function startRequest() {
    return {
        type: JOURNAL_REQUEST,
        payload: {},
    }
}

export function requestMoreSuccess(records) {
    return {
        type: JOURNAL_MORE_SUCCESS,
        payload: { records },
    }
}

export function requestSuccess(records) {
    return {
        type: JOURNAL_SUCCESS,
        payload: { records },
    }
}

export function requestError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: JOURNAL_ERROR,
        payload: errorData,
    }
}


export function requestJournal() {
    return async (dispatch, getState) => {
        dispatch(startRequest())
        const todayEnd = Math.floor(moment().endOf('day').valueOf() / 1000)

        const url = getRequestUrl(todayEnd, getState().journal)

        httpRequest(url).then(
            records => dispatch(requestSuccess(records)),
            errorData => dispatch(requestError(errorData)),
        )
    }
}

export function getRequestUrl(until, state) {
    let params = {
        limit: state.filter.limit,
        until,
    }

    const resource = state.selectedTab
    if (resource === 'reserves') {
        params.reserve_types = state.filter.reserve_types
    } else if (resource === 'resources') {
        params.actions = state.filter.actions
    } else if (resource === 'battles') {
        params.battle_type = state.filter.battle_type
        params.max_vehicle_level = state.filter.max_vehicle_level
    } else return undefined

    return `/game_api/clan_journal/${resource}${serialize(params)}`
}

export function setTab(tabName) {
    const setTabAction = () => {
        return {
            type: JOURNAL_TAB_CHANGE,
            payload: { selectedTab: tabName },
        }
    }
    return dispatch => {
        dispatch(setTabAction())
        dispatch(requestJournal())
    }
}

export function resetJournalState() {
    return {
        type: JOURNAL_RESET_STATE,
        payload: {},
    }
}



// WEBPACK FOOTER //
// ./state/actions/journal.js